import {
	FCM_STARFISH_PETITION_KICKSTART_TOGGLE,
	FCM_STARFISH_PSF_TO_SAP_LOCAL_FLOW,
	FCM_STARFISH_SALP_PERSONAL_STORY_TOGGLE,
	FCM_STARFISH_SAP_VERSION_3,
	FCM_SUNRISE_FOUNDATIONS_EXPERIENCE,
	FCM_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED,
} from '@change-corgi/fcm/configs';

import { createExperimentFcmConfig } from 'src/app/shared/hooks/experiment';

export const FCM_EXPERIMENT_PSF_TO_SAP_LOCAL_FLOW = createExperimentFcmConfig({
	experimentName: FCM_STARFISH_PSF_TO_SAP_LOCAL_FLOW.name,
	fcmConfigs: {
		config: FCM_STARFISH_PSF_TO_SAP_LOCAL_FLOW,
	},
	isEnabled: ({ fcm }) => fcm.config.isEnabled,
});

export const FCM_EXPERIMENT_STARFISH_PETITION_KICKSTART_TOGGLE = createExperimentFcmConfig({
	experimentName: FCM_STARFISH_PETITION_KICKSTART_TOGGLE.name,
	fcmConfigs: {
		enabled: FCM_STARFISH_PETITION_KICKSTART_TOGGLE,
	},
	isEnabled: ({ fcm: { enabled } }) => enabled,
});

/* eslint-disable @typescript-eslint/no-unnecessary-condition -- seems to be a bug with the types, config can be an empty object */
export const FCM_EXPERIMENT_SUNRISE_FOUNDATIONS_EXPERIENCE = createExperimentFcmConfig({
	experimentName: ({ fcm: { config } }) => config?.starterFlow?.experimentName,
	fcmConfigs: {
		config: FCM_SUNRISE_FOUNDATIONS_EXPERIENCE,
	},

	isEnabled: ({ fcm: { config } }) => !!config?.starterFlow?.enabled,
});
/* eslint-enable @typescript-eslint/no-unnecessary-condition */

export const FCM_EXPERIMENT_SALP_PERSONAL_STORY_TOGGLE = createExperimentFcmConfig({
	experimentName: FCM_STARFISH_SALP_PERSONAL_STORY_TOGGLE.name,
	fcmConfigs: {
		enabled: FCM_STARFISH_SALP_PERSONAL_STORY_TOGGLE,
	},
	isEnabled: ({ fcm: { enabled } }) => enabled,
});

export const EXPERIMENT_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED = createExperimentFcmConfig({
	experimentName: FCM_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED.name,
	fcmConfigs: {
		enabled: FCM_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED,
	},
	isEnabled: ({ fcm: { enabled } }) => enabled,
});

export const EXPERIMENT_STARFISH_SAP_VERSION_3 = createExperimentFcmConfig({
	experimentName: FCM_STARFISH_SAP_VERSION_3.name,
	fcmConfigs: {
		config: FCM_STARFISH_SAP_VERSION_3,
	},
	isEnabled: ({ fcm }) => fcm.config,
});
